module.exports = __webpack_public_path__ + "static/media/joffre-15.4a5861f6.jpg";